<template>
  <v-app>
    <super-admin-navigation/>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer dark padless color="primary darken-4">
      <v-container fluid>
        <v-row justify="center" dense class="py-2">
          <v-col class="caption text-center white--text" cols="12">
            All Rights Reserved &copy; {{ new Date().getFullYear() }} — <strong>KANU Party</strong>
          </v-col>
          <v-col class="caption text-center white--text" cols="12">
            <span>www.nominations.kanuparty.org</span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import SuperAdminNavigation from "@/components/navigation/SuperAdminNavigation";

export default {
  name: "superAdminLayout",
  components: { SuperAdminNavigation },
  metaInfo: {
    title: 'KANU Party Nomination',
    titleTemplate: '%s | KANU Party Nomination',
    htmlAttrs: { lang: 'en' }
  },
}
</script>

<style scoped>
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
